import { makeStyles, Theme } from '@material-ui/core'
import { ButtonProps } from './ButtonProps'

export const useButtonStyles = makeStyles<Theme, ButtonProps>(() => ({
  root: {
    minWidth: 'unset',
  },
  label: {
    textTransform: ({ textTransform }) => textTransform,
  },
}))
